import { Cpu, FlaskConical, ScrollText, type LucideIcon } from 'lucide-react';

// 诊断的一级导航。定位是「排查线上问题」（console/docs/specs/内部后台命名与入口.md）：
// 查一台设备、一次对话、一段音频。2026-10-05 汤祺定只留设备与测网设备两个模块；
// 活跃、留存、功能使用这类「产品好不好用」的分析归产品分析，不在这里。
// 「查看记录」是全员可见的设备内容查看台账（console/docs/specs/问题诊断查看权限.md，汤祺 2026-10-07）。
export const NAV: { href: string; label: string; icon: LucideIcon; hint: string }[] = [
  { href: '/devices', label: '设备', icon: Cpu, hint: '按 SN 找一台设备，看状态、对话、记忆与音频' },
  { href: '/test-devices', label: '测网设备', icon: FlaskConical, hint: '测试网络的设备与对话' },
  { href: '/access-log', label: '查看记录', icon: ScrollText, hint: '谁在哪天看了哪台设备的内容、为什么' },
];

export function isActive(pathname: string, href: string): boolean {
  return pathname === href || pathname.startsWith(`${href}/`);
}
